/**
 * BrandLogo — يعرض الشعار الرسمي من ملف الأصل فقط.
 *
 * ⛔ لا يرسم الرمز ولا يولّده برمجياً ولا يعيد بناءه من الذاكرة.
 *    الرمز في الـBrand Book (طبقات هندسية متداخلة نحو مركز/إشارة قيمة) يُصدَّر
 *    من ملف المصدر الأصلي ويوضع في `public/brand/nitaq/`.
 *
 * ما دام الملف غير متوفر، نعرض **الاسم كتابةً فقط** — وهذا استخدام طباعي
 * مشروع، لا شعار بديل. لا نضع أيقونة عقارية ولا شكلاً مؤقتاً.
 *
 * مبدأ الـBrand Book داخل المنتج: «الشعار صغير، البيانات هي البطل.»
 */

import { useState } from 'react';
import { color } from '@/design/tokens';

/**
 * الرمز الرسمي متحرّكاً، وثابتُه احتياطاً.
 *
 * نفس الهندسة في الملفّين — المتحرّك يغيّر الشفافية والمقياس فقط، والحركة
 * داخل الـSVG لا في الصفحة، فتسكن وحدها مع `prefers-reduced-motion`.
 * السقوط إلى الثابت عند تعذّر تحميل المتحرّك: شعار حاضر أولى من فراغ.
 */
const SYMBOL_ANIMATED = '/brand/nitaq/symbol-animated.svg';
const SYMBOL_STATIC = '/brand/nitaq/symbol.svg';

export function BrandLogo({
  size = 26,
  showWordmark = true,
}: {
  size?: number;
  showWordmark?: boolean;
}): JSX.Element {
  // غياب الأصل ليس خطأً — هو الحالة الحالية المسجّلة في BRAND-FREEZE.
  const [symbolAvailable, setSymbolAvailable] = useState(true);
  const [asset, setAsset] = useState(SYMBOL_ANIMATED);

  return (
    <span
      data-testid="brand-logo"
      style={{ display: 'inline-flex', alignItems: 'center', gap: 10, minWidth: 0 }}
    >
      {symbolAvailable ? (
        <img
          src={asset}
          alt=""
          aria-hidden="true"
          width={size}
          height={size}
          style={{ display: 'block', flex: '0 0 auto' }}
          onError={() => {
            if (asset === SYMBOL_ANIMATED) setAsset(SYMBOL_STATIC);
            else setSymbolAvailable(false);
          }}
        />
      ) : null}

      {showWordmark ? (
        <span
          style={{
            fontSize: 19,
            fontWeight: 700,
            letterSpacing: '-.01em',
            color: color.text,
            whiteSpace: 'nowrap',
          }}
        >
          نطاق
        </span>
      ) : null}
    </span>
  );
}
